import * as Raven from 'raven-js';
import {ErrorHandler} from '@angular/core';
Raven
  .config('https://18926e522d6244e28cd2180a6e7d8965@sentry.io/253371')
  .install();

export class RavenErrorHandler implements ErrorHandler {
  handleError(err:any) : void {
  	console.error(err);
    Raven.captureException(err);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/raven.ts